{
  "dodo.common.close": "Close",
  "dodo.common.continue": "Continue",
  "dodo.errors.idle.action": "Riprova",
  "dodo.errors.idle.headline": "Servizio attualmente non disponibile",
  "dodo.errors.idle.line1": "Riprovare più tardi.",
  "dodo.feedback.comments": "Please share any additional comments, suggestions or improvement opportunities. How it can be more valuable to you?",
  "dodo.feedback.description": "Your feedback is very important, so we can improve our services",
  "dodo.feedback.disclaimer.headline": "No worries, your answer will be anonymised!",
  "dodo.feedback.disclaimer.line1": "Your name and e-mail won't be linked to your answer.",
  "dodo.feedback.headline": "On a scale from 1-5, how satisfied are you with {subject}?",
  "dodo.feedback.placeholder": "Write your feedback here",
  "dodo.feedback.satisfied": "Very satisfied",
  "dodo.feedback.success.line1": "Thanks for using and contributing to our services.",
  "dodo.feedback.success.title": "Your feedback was successfully registered",
  "dodo.feedback.unsatisfied": "Very unsatisfied",
  "dodo.maintenance.actionText": "Torna alla pagina principale",
  "dodo.maintenance.description": "A volte abbiamo bisogno di una breve pausa per eseguire manutenzioni essenziali e/o aggiornamenti nei nostri servizi. Apprezziamo la vostra comprensione.",
  "dodo.maintenance.headline": "Spiacente, siamo attualmente in manutenzione programmata"
}